export default "__VITE_ASSET__1NsvL_QO__"